const backgroundRemover = {
  backgroundRemoverTitle: 'HitPaw Online AI Background Remover',
  NoWatermark: "Sem marca d'água",
  UnlimitedHDExport: 'Exportações HD ilimitadas',
  NoFileSizeLimit: 'Sem limite de tamanho de arquivo',
  BatchProcessing: 'Processamento em lote',
  UseAllTemplates:
    'Todos os modelos, fundos, elementos, texto estão disponíveis',
  CancelAtAnytime: 'Cancelar assinatura a qualquer momento',
  HighPriorityUnlimited: 'Processamento ilimitado de alta prioridade',
  YearDayPrice: 'R$0,66',
  YearTotalPrice: 'R$238,99',
  MonthDayPrice: 'R$1,99',
  MonthTotalPrice: 'R$40,99',
  WeekDayPrice: 'R$2,99',
  WeekTotalPrice: 'R$19,99',
  Day: 'Dia',
  Monthly: 'Mensalmente',
  Weekly: 'Semanalmente',
  Yearly: 'Anualmente',
};

export default backgroundRemover;
